import axios from "axios"
const url = process.env.REACT_APP_BANKVERIFY_URL




export const CreatePaymentOrder=async(data,prids,setIsLoading,handleAlertOpen)=>{
    try{
        setIsLoading(true)
        await axios.post(`${url}procurement/purchase/payment_orders/add`,{...data,purchase_request_ids:prids},{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message?res.data.message:"Payment Order created successfully","success")
            setTimeout(()=>{
                window.location.reload()
            },1500)
        })
    }
    catch(error){
        setIsLoading(false)
        // console.log(error);   
        handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    }
}


export const GetPaymentOrders=async(setIsLoading,handleAlertOpen,setData,page,status,UserRole,filters)=>{
    console.log("status",status);
    
    try{
        setIsLoading(true)
        await axios.get(`${url}procurement/purchase/payment_orders`,{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            },
            params:{
                status:status.toLowerCase(),
                page:page,
                from_date: filters.from_date.split('-').reverse().join('-'),
                to_date: filters.to_date.split('-').reverse().join('-'),
                device: filters.device,
                ...UserRole,
            }
        })
        .then((res)=>{
            setIsLoading(false)
            setData(res.data)
        })
    }
    catch(error){   
        console.log("errors",error);
        setIsLoading(false)
        handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong!!!","error")
    }
}


export const ApprovePaymentOrder=async(data,setIsLoading,handleAlertOpen)=>{
    try{
        setIsLoading(true)
        await axios.post(`${url}procurement/purchase/payment_orders/update`,data,{
            headers:{
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                }
            }
        )
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message?res.data.message:"Payment Order approved successfully","success")
            setTimeout(()=>{
                window.location.reload()
            },1500)
    })
}
catch(error){
    setIsLoading(false)
    handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
}
        
}


export const CompletePayment=async(data,id,setIsLoading,handleAlertOpen)=>{
    // console.log("id",id);
    
    let postData={...data,payment_order_id:id}
    try{
        setIsLoading(true)
        await axios.post(`${url}procurement/purchase/complete_payment`,postData,{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
        .then((res)=>{
            setIsLoading(false)
            handleAlertOpen(res.data.message?res.data.message:"Payment Order completed successfully","success")
            setTimeout(()=>{
                window.location.reload()
            },1500)
        })
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    }
}


export const GetUniquePurchaseOrder=async(id,setIsLoading,handleAlertOpen,setData)=>{
    try{
        setIsLoading(true)
        await axios.get(`${url}procurement/purchase/purchase_orders/${id}`,{
            headers:{
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
        .then((res)=>{
            setIsLoading(false)
            setData(res.data)
        })
    }
    catch(error){
        setIsLoading(false)
        handleAlertOpen(error.response&&error.response.data.error?error.response.data.error:"Something went wrong","error")
    }
}
